import React from 'react'
import appassets from '../utils/appassets'
import { TextRegular } from './TextStyling'

const NoRecordFound = ({ title, style }) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <div>
        <img src={appassets.emptydata} alt='empty-jobs' style={{ ...style }} />
      </div>
      <div>
        <TextRegular style={{ fontSize: '18px' }}>
          {title === '' ? <>No Record Found</> : title}
        </TextRegular>
      </div>
    </div>
  )
}

export default NoRecordFound
